<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Relatórios</h4>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListReports v-else :reports="reports" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ListReports from '@/components/ethos/reports/ListReports.vue'

export default {
  name: 'Reports',

  components: {
    LoadingData,
    ListReports,
  },

  data() {
    return {
      isLoadingData: true,
      reports: [],
    }
  },

  methods: {
    async getReports() {
      try {
        this.reports = await this.$store.dispatch('getReports')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getReports()
  },
}
</script>
